import * as MT from "./mutationTypes";
import Auth from "@/packages/auth";

export default {
  [MT.SET_NAVIGATION_STATE]: (state, data) => (state.navigationDrawer = data.drawer),
  [MT.SET_EXPORTERS]: (state, data) => (state.exporters = data.data),
  [MT.SET_TIME_PERIODS]: (state, data) => {
    if (data.data !== undefined) {
      state.timePeriods = data.data;
    } else {
      state.timePeriods = data;
    }
  },
  [MT.DELETE_TIME_PERIOD]: (state, data) => {
    const timePeriodIndex = state.timePeriods.findIndex(timePeriod => timePeriod.id === data.data.id);
    if (timePeriodIndex !== undefined && timePeriodIndex !== null) {
      state.timePeriods.splice(timePeriodIndex, 1);
    }
    Auth.destroyTimePeriods();
    const timePeriodsData = {
      timePeriods: state.timePeriods
    };
    Auth.setTimePeriods(timePeriodsData);
    return;
  },
  [MT.ADD_TIME_PERIOD]: (state, data) => {
    //state.timePeriods = data.data
    if (data && data.data) {
      const timePeriodExists = state.timePeriods.some(timePeriod => {
        return timePeriod.id === data.data.id;
      });
      if (!timePeriodExists) {
        state.timePeriods.push(data.data);
        Auth.destroyTimePeriods();
        const timePeriodsData = {
          timePeriods: state.timePeriods
        };
        Auth.setTimePeriods(timePeriodsData);
      }
    }
  },
  [MT.DELETE_TIME_PERIOD]: (state, data) => {
    if (data && data.id) {
      state.timePeriods = state.timePeriods.filter(timePeriod => {
        return timePeriod.id !== data.id;
      });
      Auth.destroyTimePeriods();
      const timePeriodsData = {
        timePeriods: state.timePeriods
      };
      Auth.setTimePeriods(timePeriodsData);
    }
  },
  [MT.SET_ACCOUNT_STATE]: (state, account) => (state.account = account)
};
